import { stateNameOf } from "../../stateUtils"

export const isState = (slug: string): boolean => {
  const regEx: RegExp = /^[A-z]{2}$/;
  const stateName = regEx.test(slug) ? stateNameOf(slug) : "";
  return !!stateName;
}
